import { ALTERAR_DETALHAMENTO_ENCOMENDA } from '../types'

export default function alterarExibicaoEncomenda (pedido) {
  return {
    type: ALTERAR_DETALHAMENTO_ENCOMENDA,
    payload: pedido
  }
}
